<template>
  <div class="column-page">
    <searchComponent />
    <div
      v-loading="moduleLoading"
      class="column-view"
    >
      <!-- 栏目详情 -->
      <gambitList
        v-if="!moduleLoading && !$route.params.propType"
        :list="gambitList"
        :class="{'no-title': gambitList.Name}"
        @showArticle="getArticle"
      />
      <!-- 栏目详情下的列表点击更多后的数据 -->       
      <div v-if="!moduleLoading && $route.params.propType">
        <a class="pointer go-back-a" @click="toColumn">&lt;&lt;返回栏目</a>
        <documentList
          :list="documentData"
          @showArticle="getArticle"
          @pageChange="getDocument"
        />
      </div>   
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

// component
import gambitList from '@/modules/history/gambit-list.vue'
import documentList from '@/modules/history/document-list.vue'
import searchComponent from '@/components/searchComponent'

// service
import * as service from '@/service/httpService'
import GetColumnInformation from '@/service/getColumnInfo'
import { globalService } from '@/service/globalService'
import { historyEventService } from '@/service/httpService'

export default {
  name: 'ColumnView',
  components: {
    documentList,
    gambitList,
    searchComponent
  },
  data () {
    return {
      moduleLoading: true,
      gambitList: {},
      documentData: {}
    }
  },
  computed: {
    ...mapState({
      isLogin: 'isLogin',
      comeFromOldSystem: 'comeFromOldSystem'
    }),
    getId () {
      return this.$route.params.id
    },
    currentLibrary () {
      return this.$route.params.library.toLowerCase()
    },
    currentUrls () {
      // 当前库对应map 依次是：事件库，人物库， 机构库，地方库， 口述库， 实物库， 中改院
      let libraryMap = {
        historyaccount: ['columnDictatorCheck', 'documentsDictator'],
        historyobject: ['columnMaterialCheck', 'documentsMaterial'],
        1: ['columnCheck', 'documents'],
        2: ['columnPersonCheck', 'documentsPerson'],
        3: ['columnOrganizationCheck', 'documentsOrganization'],
        4: ['columnRegionCheck', 'documentsRegion'],
        5: ['columnDictatorCheck', 'documentsDictator'],
        6: ['columnMaterialCheck', 'documentsMaterial'],
        7: ['columnCirdCheck', 'documentsCird']
      }
      return libraryMap[this.currentLibrary]
    }
  },
  watch: {
    '$route' (val) {
      if (val.params.propType) {
        this.getDocument()
      }
    }
  },
  mounted () {
    this.mountedPage()
  },
  methods: {
    mountedPage () {
      this.getColumnInfo(window.dataUrl.History[this.currentUrls[0]], window.dataUrl.History[this.currentUrls[1]])
    },
    getColumnInfo (...url) {
      this.moduleLoading = true
      var loadColumn = new GetColumnInformation(
        this,
        ...url
      )
      loadColumn.getColumn()
    },
    getDocument (currentPage) {
      let params = this.$route.params
      this.moduleLoading = true
      let documentUrl = window.dataUrl.History[this.currentUrls[1]].replace('{id}', params.column)
      historyEventService.loadColums(documentUrl, {propType: params.propType, page: currentPage, pageSize: 20}).then(res => {
        this.moduleLoading = false
        this.documentData = res.data
      }, () => {
        this.$message({type: 'error', message: '请求数据失败'})
      })
    },
    getArticle (id) {
      globalService.showArticle(id, this)
    },
    toColumn () {
      const param = this.$route.params
      this.$router.push({
        path: `/column/${param.library}/${param.column}`,
        query: this.$route.query
      })
    }
  }
}
</script>


<style lang="scss">
.column-page {
  // position: absolute;
  // top: 65px;
  // bottom: 0;
  width: 100%;
  overflow-y: auto;

  .left {
    margin-top: 0 !important;
  }

  strong {
    font-weight: bold;
  }
  em {
    font-style: italic;
  }
  ol {
    list-style: decimal;
  }
  ul {
    list-style: disc;
  }
  .column-view {
    width: 1000px;
    margin: 30px auto 50px;
    line-height: 30px;

    .go-back-a {
      color: #999;
      margin-left: 10px;
    }

    .title {
      font-size: 24px;
    }
    .subtitle {
      margin: 5px;
      font-size: 20px;
    }
  }
  .recommend-title {
    font-size: 18px;
    font-weight: bold;
  }
  .content {
    text-indent: 2em;
  }
  .lock-icon {
    float: right;
    width: 14px;
    height: 14px;
    margin-top: 5px;
    background: url('../../assets/img/lock.png') no-repeat;
    background-size: 100% 100%;
  }
}

</style>


// WEBPACK FOOTER //
// src/modules/history/column-view.vue